(function () {
  if (window.imStorefrontEventsBound) return;
  window.imStorefrontEventsBound = true;

  function setMenuState(menu, open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    document.querySelectorAll('[aria-controls="' + menu.id + '"]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function updateCartCount(count) {
    document.querySelectorAll('.im-icon-link[aria-label="Cart"]').forEach(function (cartLink) {
      var badge = cartLink.querySelector('.im-cart-count');

      if (count < 1) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'im-cart-count';
        cartLink.appendChild(badge);
      }

      badge.textContent = count;
    });
  }

  function quickAddIcon(type) {
    if (type === 'success') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
    }

    if (type === 'error') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg>';
    }

    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  }

  function resetQuickAddButton(button, label, delay) {
    window.setTimeout(function () {
      button.innerHTML = quickAddIcon('default');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-label', label);
      button.removeAttribute('title');
    }, delay);
  }

  async function addProductWithoutRedirect(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var variantId = button.getAttribute('data-variant-id');
    var productTitle = button.getAttribute('data-product-title') || 'product';
    if (!variantId) return;

    var originalLabel = button.getAttribute('aria-label') || 'Add product to cart';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      var addResponse = await fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        credentials: 'same-origin'
      });

      var addResult = await addResponse.json();
      if (!addResponse.ok) {
        throw new Error(addResult.description || addResult.message || 'This item could not be added.');
      }

      var addedItem = addResult.items && addResult.items.length ? addResult.items[0] : addResult;

      var cartResponse = await fetch(shopRoot() + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      var cart = await cartResponse.json();

      updateCartCount(cart.item_count || 0);
      button.innerHTML = quickAddIcon('success');
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-label', 'Added ' + (addedItem.product_title || productTitle) + ' to cart');

      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart, item: addedItem }
      }));

      resetQuickAddButton(button, originalLabel, 1400);
    } catch (error) {
      button.innerHTML = quickAddIcon('error');
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-label', 'Could not add product to cart');
      button.setAttribute('title', error.message || 'Could not add product to cart');
      resetQuickAddButton(button, originalLabel, 2200);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-im-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addProductWithoutRedirect(button);
  }, true);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-im-menu-toggle]');
    if (toggle) {
      event.preventDefault();
      var menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (menu) setMenuState(menu, !menu.classList.contains('is-open'));
      return;
    }

    var closeButton = event.target.closest('[data-im-menu-close]');
    if (closeButton) {
      event.preventDefault();
      setMenuState(closeButton.closest('.im-mobile-nav'), false);
      return;
    }

    var soundButton = event.target.closest('[data-im-video-sound]');
    if (soundButton) {
      var videoCard = soundButton.closest('.im-video-card');
      var video = videoCard && videoCard.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      soundButton.classList.toggle('is-sound-on', !video.muted);
      soundButton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      soundButton.querySelector('span').textContent = video.muted ? 'Sound off' : 'Sound on';
      if (video.paused) video.play().catch(function () {});
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.im-mobile-nav.is-open').forEach(function (menu) {
      setMenuState(menu, false);
    });
  });


  function initializeMobileStickyHeaders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headers = scope.querySelectorAll('.im-header.is-sticky');

    headers.forEach(function (header) {
      if (header.getAttribute('data-im-mobile-sticky-bound') === 'true') return;
      header.setAttribute('data-im-mobile-sticky-bound', 'true');

      var mobileMedia = window.matchMedia('(max-width: 820px)');
      var spacer = document.createElement('div');
      var stickyStart = 0;
      var animationFrame = null;

      spacer.className = 'im-header-sticky-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      header.parentNode.insertBefore(spacer, header);

      function scrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
      }

      function setFixed(fixed) {
        var shouldFix = mobileMedia.matches && fixed;
        header.classList.toggle('is-mobile-fixed', shouldFix);
        spacer.style.height = shouldFix ? header.offsetHeight + 'px' : '0px';
      }

      function update() {
        animationFrame = null;
        setFixed(scrollTop() >= stickyStart);
      }

      function requestUpdate() {
        if (animationFrame !== null) return;
        animationFrame = window.requestAnimationFrame(update);
      }

      function measure() {
        var wasFixed = header.classList.contains('is-mobile-fixed');
        header.classList.remove('is-mobile-fixed');
        stickyStart = spacer.getBoundingClientRect().top + scrollTop();

        if (!wasFixed) spacer.style.height = '0px';
        update();
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);

      if (mobileMedia.addEventListener) {
        mobileMedia.addEventListener('change', measure);
      } else if (mobileMedia.addListener) {
        mobileMedia.addListener(measure);
      }

      measure();
    });
  }

  initializeMobileStickyHeaders(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeMobileStickyHeaders(event.target);
  });

})();
